module.exports = __webpack_public_path__ + "img/puesta-en-valor-1.50f468e5.jpg";